import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
import { NerdWalletLogo } from '@repo/ui/NerdWalletLogo';
export function Header() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    });
    t1 = <NerdWalletLogo variant="verbose" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={t0}>{t1}<Dialog.Close render={<button type="button" aria-label="Close modal" className={css({
        bg: "[transparent]",
        border: "none",
        cursor: "pointer",
        color: "neutral.darker",
        width: "[30px]",
        height: "[30px]",
        rounded: "full",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: "[0px]",
        _hover: {
          bg: "neutral.lightest"
        }
      })}><CloseIcon /></button>} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}